import { apiDelete } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";

interface DeleteExamAssignmentResponse {
  success: boolean;
  message: string;
}

/**
 * 시험 할당 삭제 API 함수
 * @param id 시험 할당 ID
 * @returns API 응답 객체
 */
export async function deleteExamAssignment(id: string) {
  const response = await apiDelete<{ message: string }>(
    `/exam_assignments/${id}`
  );
  return response.data;
}

/**
 * 시험 할당 삭제 React Query 훅
 * @returns 뮤테이션 객체
 */
export function useDeleteExamAssignment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteExamAssignment,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["examAssignments"] });
    },
  });
}

export default useDeleteExamAssignment;
